/**
 * Pausar (motivo opcional) e cancelar (motivo obrigatório): os motivos
 * prontos da unidade viram botões, com campo livre para o resto. Os motivos
 * vêm do pacote do aparelho, então funcionam também sem internet.
 */
import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { Aviso, BotaoPerigo, BotaoPrimario, BotaoSecundario, Campo, Mono } from "../styles";
import Folha from "./Folha";

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  button {
    min-height: 30px;
    padding: 0 12px;
    border-radius: 999px;
    border: 1px solid var(--border-strong);
    background: var(--surface);
    color: var(--ink);
    font: inherit;
    font-size: 13px;
    cursor: pointer;
  }

  button[aria-pressed="true"] {
    border-color: var(--accent);
    background: var(--accent-soft);
    color: var(--ink);
    font-weight: 600;
  }
`;

const OUTRO = "__outro__";
/** O backend guarda até 200 caracteres; passar disso recusaria o toque na fila. */
const TAMANHO_MAXIMO = 200;

export default function MotivoFolha({ tipo, aberta, onFechar, onConfirmar, motivos = [], identificador, passoTexto, concluidos }) {
  const ehCancelar = tipo === "cancelamento";
  const [escolhido, setEscolhido] = useState("");
  const [livre, setLivre] = useState("");
  const [erro, setErro] = useState("");

  useEffect(() => {
    if (!aberta) return;
    setEscolhido("");
    setLivre("");
    setErro("");
  }, [aberta]);

  const motivoFinal = () => {
    const texto = escolhido && escolhido !== OUTRO ? [escolhido, livre.trim()].filter(Boolean).join(" · ") : livre.trim();
    return texto.slice(0, TAMANHO_MAXIMO);
  };

  const confirmar = () => {
    const motivo = motivoFinal();
    if (ehCancelar && !motivo) {
      setErro("Escolha um motivo para cancelar.");
      return;
    }
    onConfirmar(motivo);
  };

  const subtitulo = ehCancelar
    ? `Sai de Em andamento e vai para o Histórico como cancelada. ${concluidos ? `Os ${concluidos} passos feitos ficam registrados.` : ""}`
    : `Parado no ${passoTexto}. Continuar abre direto aqui.`;

  return (
    <Folha
      aberta={aberta}
      onFechar={onFechar}
      titulo={ehCancelar ? "Cancelar esta execução?" : "Pausar este lote?"}
      acoes={
        <>
          <BotaoSecundario type="button" onClick={onFechar}>
            {ehCancelar ? "Manter aberta" : "Continuar trabalhando"}
          </BotaoSecundario>
          {ehCancelar ? (
            <BotaoPerigo type="button" onClick={confirmar}>Cancelar execução</BotaoPerigo>
          ) : (
            <BotaoPrimario type="button" onClick={confirmar}>Pausar</BotaoPrimario>
          )}
        </>
      }
    >
      {identificador ? (
        <p style={{ margin: "-6px 0 0", fontSize: 13, color: "var(--ink-2)" }}>
          <Mono>{identificador}</Mono>
        </p>
      ) : null}
      <p style={{ margin: 0, fontSize: 13, color: "var(--ink-2)" }}>{subtitulo}</p>
      <Chips role="group" aria-label="Motivos prontos">
        {[...motivos.map((m) => m.texto), OUTRO].map((texto) => (
          <button
            key={texto}
            type="button"
            aria-pressed={escolhido === texto}
            onClick={() => {
              setEscolhido(escolhido === texto ? "" : texto);
              setErro("");
            }}
          >
            {texto === OUTRO ? "Outro" : texto}
          </button>
        ))}
      </Chips>
      <Campo>
        <span>{escolhido && escolhido !== OUTRO ? "Observação (opcional)" : "Motivo"}</span>
        <input
          value={livre}
          onChange={(e) => {
            setLivre(e.target.value);
            setErro("");
          }}
          placeholder={ehCancelar ? "Ex.: projeto voltou para o projetista" : "Ex.: falta cadastrar 18mm MDF Freijó"}
          maxLength={180}
        />
      </Campo>
      {erro ? <Aviso $tom="danger" role="alert">{erro}</Aviso> : null}
    </Folha>
  );
}
